<template>
  <div
    class="h-screen flex justify-center items-center bg-no-repeat bg-center bg-cover bg-fixed bg-opacity-50"
  >
    <div class="background-layer"></div>
    <!-- GO BACK -->
    <div
      @click="$router.go(-1)"
      class="cursor-pointer flex justify-center items-center p-3 animate-pulse dark:text-white absolute left-2 top-0 nesthub:top-10 text-sm md:text-xl"
    >
      <i class="fa-solid fa-circle-arrow-left"></i>
      <span class="ml-2">{{ $t("message.other.back") }}</span>
    </div>

    <!-- SLIDE -->
    <swiper
      class="size"
      :slides-per-view="1"
      :navigation="true"
      :loop="true"
      :initialSlide="1"
      :autoplay="{
        delay: 7000,
        disableOnInteraction: false,
      }"
      :pagination="{
        clickable: true,
      }"
      :modules="modules"
    >
      <swiper-slide v-for="img of db" :key="img.id">
        <!-- IMAGE -->
        <div
          class="bg-cover bg-center w-full h-full lazy-skeleton"
          :lazy-background="img.src"
        ></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { useAlbumsStore } from "../../store/AlbumsStore";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js";
import { Pagination, Autoplay, Navigation } from "swiper";
import "swiper/swiper-bundle.css";

export default {
  name: "Album",
  props: ["id"],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    const store = useAlbumsStore();

    return {
      store: store,
      db: [],
    };
  },
  async mounted() {
    await this.store.getAlbum(this.id);

    this.db = this.store.getImagesByFolderId(this.id);

    if (this.db.length == 0) {
      this.$router.go(-1);
    }
  },
  setup() {
    return {
      modules: [Pagination, Autoplay, Navigation],
    };
  },
};
</script>

<style scope>
.size {
  width: 60rem;
  height: 40rem;
  max-width: 100vw;
}

@media only screen and (max-width: 728px) {
  .size {
    height: 20rem;
  }
}

@media screen and (orientation: landscape) and (max-width: 1025px) {
  .size {
    height: 80vh !important;
    width: 120vh !important;
  }
}

.swiper-pagination-bullet {
  background-color: #ffffff;
}

.swiper-pagination-bullet-active {
  background-color: red !important;
}

.swiper-button-next,
.swiper-button-prev {
  color: red !important;
  fill: red !important;
  stroke: red !important;
}
.background-layer::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("/static/photos/fond.svg") center/cover fixed no-repeat;
  background-attachment: fixed;
  opacity: 0.5; /* Réglez l'opacité selon vos besoins */
}
</style>
